<template>
  <div class="auth-wrapper">
    <img src="@/assets/logo-CorWfPtl.png" alt="Logo" class="auth-logo" />

    <div class="auth-container">
      <h2>Zaloguj się do Panelu Administatora</h2>

      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="email">Email</label>
          <input v-model="email" id="email" type="email" required />
        </div>

        <div class="form-group">
          <label for="password">Hasło</label>
          <input v-model="password" id="password" type="password" required />
        </div>

        <button type="submit" class="login-button" :disabled="auth.loading">
          {{ auth.loading ? 'Logowanie...' : 'Zaloguj się' }}
        </button>

        <div class="links">
          <router-link to="/cms/forgot-password">Zapomniałeś hasła?</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'

export default {
  name: 'AuthPage',
  data() {
    return {
      email: '',
      password: '',
      auth: useAuthStore(),
    }
  },
  computed: {
    error() {
      if (!this.auth.error) return null
      if (this.auth.error === 'These credentials do not match our records.') {
        return 'Błędny email lub hasło.'
      }
      return 'Wystąpił błąd logowania.'
    }
  },
  mounted() {
    if (this.auth.isLoggedIn) {
      this.$router.replace('/cms')
    }
  },
  methods: {
    async handleLogin() {
      try {
        await this.auth.login({
          email: this.email,
          password: this.password,
        })
        this.$router.push('/cms')
      } catch (err) {
        console.warn('Logowanie nieudane:', err)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.auth-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: $color-grey-light;
  padding: 2rem;
}

.auth-logo {
  max-width: 250px;
  margin-bottom: 3rem;
}

.auth-container {
  max-width: 400px;
  width: 100%;
  background-color: $color-white;
  padding: 2rem 2.5rem;
  border-radius: 12px;
  box-shadow: 0 0 20px $color-shadow;
  font-family: 'Inter', sans-serif;
  color: $color-text;
}

h2 {
  text-align: center;
  margin-bottom: 2rem;
  color: $color-primary-dark;
}

.form-group {
  margin-bottom: 1.5rem;
  display: flex;
  flex-direction: column;
}

.links {
  margin-top: 1rem;
  text-align: center;

  a {
    color: $color-primary;
    text-decoration: none;
    font-size: 0.9rem;

    &:hover {
      text-decoration: underline;
    }
  }
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: $color-text-light;
}

input {
  padding: 0.6rem 0.8rem;
  border: 1px solid $color-grey-dark;
  border-radius: 8px;
  font-size: 1rem;
  background-color: $color-grey-light;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: $color-primary;
  }
}

.login-button {
  width: 100%;
  padding: 0.7rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  background-color: $color-primary;
  color: $color-white;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: $color-primary-dark;
  }
}
</style>